import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, startWith } from 'rxjs/operators';

@Pipe({
    name: 'withLoading',
    standalone: false
})
export class WithLoadingPipe implements PipeTransform {
  transform<T>(value: Observable<InputValue<T>>): Observable<LoadingObject<T>> {
    return value.pipe(
      startWith({ loading: true }),
      catchError((error) => of({ loading: false, error })),
    );
  }
}

export interface LoadingObject<T> {
  loading: boolean;
  value?: T;
  error?: Error;
}

export interface InputValue<T> {
  value?: T;
  loading: boolean;
}
